var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['rv-box-design', _vm.isSelectedDesign() ? 'selected' : '']},[_c('img',{key:_vm.designNr,attrs:{"alt":_vm.designNr,"title":_vm.name,"src":_vm.link},on:{"click":function($event){return _vm.onSelectDesign()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }